<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <!--            <el-form-item label="类目ID" prop="categoryId">-->
            <!--                <el-input v-model="dataForm.categoryId" placeholder="类目ID"></el-input>-->
            <!--            </el-form-item>-->
            <el-form-item label="名称" prop="name">
                <el-input v-model="dataForm.name" placeholder="名称"></el-input>
            </el-form-item>
            <el-form-item label="图片">
                <el-upload :class="{hide:hideUpload}"
                           :action="this.uploadUrl"
                           :headers="headers" list-type="picture-card" :file-list="mainFileList"
                           :before-upload="beforeAvatarUpload"
                           :on-success="handleAvatarSuccess" :on-preview="handlePictureCardPreview"
                           :on-remove="handleRemove" :limit="1">
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>

            <el-form-item label="类型" prop="type">
                <template>
                    <el-radio-group v-model="dataForm.type">
                        <el-radio :label=0>产品</el-radio>
                        <el-radio :label=1>外链</el-radio>
                    </el-radio-group>
                </template>
            </el-form-item>
            <el-form-item v-if="dataForm.type===0" label="产品" prop="productId">
                <el-select v-model="dataForm.productId" placeholder="请选择产品">
                    <el-option v-for="(item,index) in productList" :key="index" :label="item.name"
                               :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="dataForm.type===1" label="链接地址" prop="linkUrl">
                <el-input v-model="dataForm.linkUrl" placeholder="链接地址"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="note">
                <el-input v-model="dataForm.note" placeholder="备注"></el-input>
            </el-form-item>
            <!--            <el-form-item label="排序方式(数字越大越靠前)" prop="sort">-->
            <!--                <el-input v-model="dataForm.sort" placeholder="排序方式(数字越大越靠前)"></el-input>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="删除状态(1未删除；2已删除)" prop="deleteStatus">-->
            <!--                <el-input v-model="dataForm.deleteStatus" placeholder="删除状态(1未删除；2已删除)"></el-input>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="部门ID" prop="deptId">-->
            <!--                <el-input v-model="dataForm.deptId" placeholder="部门ID"></el-input>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="更新时间" prop="updateDate">-->
            <!--                <el-input v-model="dataForm.updateDate" placeholder="更新时间"></el-input>-->
            <!--            </el-form-item>-->
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from 'lodash/debounce'
    import Cookies from "js-cookie";

    export default {
        data() {
            return {
                visible: false,
                mainFileList: [],
                hideUpload: false,
                productList: [],
                //图片上传
                headers: {
                    token: this.cookie.get('token')
                },
                dialogImageUrl: '',
                dialogVisible: false,
                uploadUrl: '',
                dataForm: {
                    id: '',
                    categoryId: '',
                    name: '',
                    picture: '',
                    linkUrl: '',
                    note: '',
                    sort: '',
                    deleteStatus: '',
                    creator: '',
                    deptId: '',
                    createDate: '',
                    updateDate: '',
                    type: 0,
                    productId: ''
                }
            }
        },
        computed: {
            dataRule() {
                return {
                    categoryId: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    name: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    picture: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    linkUrl: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    note: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    sort: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    deleteStatus: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    deptId: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    updateDate: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            init() {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    this.mainFileList = []
                    this.hideUpload = false
                    this.getProductInfo()
                    if (this.dataForm.id) {
                        this.getInfo()
                    }
                })
                this.uploadUrl = `${window.SITE_CONFIG['apiURL']}/sys/oss/upload?token=${Cookies.get('token')}`
            },
            // 获取信息
            getInfo() {
                this.$http.get(`/sms/banneradvertise/${this.dataForm.id}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm = {
                        ...this.dataForm,
                        ...res.data
                    }
                    //初始化图
                    this.mainFileList = []
                    this.mainFileList = [{
                        name: 'main.jpeg',
                        url: this.dataForm.picture
                    }]
                }).catch(() => {
                })
            },
            // 获取信息
            getProductInfo() {
                this.$http.get(`/pms/product/page`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    console.info(res)
                    this.productList = res.data.list
                    console.info(this.productList)
                }).catch(() => {
                })
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function () {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    console.log(this.dataForm)
                    this.$http[!this.dataForm.id ? 'post' : 'put']('/sms/banneradvertise/', this.dataForm).then(({data: res}) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {
                    })
                })
            }, 1000, {'leading': true, 'trailing': false}),
            //文件上传
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isLt2M) {
                    this.$message.error('图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            handleAvatarSuccess(res, file, fileList) {
                // this.dataForm.mainPicture = URL.createObjectURL(file.raw);
                this.dataForm.picture = res.data.src;
                this.hideUpload = fileList.length >= 1;
            },
            handleRemove(file, fileList) {
                this.dataForm.picture = ''
                this.hideUpload = fileList.length >= 1;
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },

            addAttribute() {
                this.dataForm.attribute.push({
                    name: this.attributeName,
                    value: []
                })
                this.attributeName = ''
            },
            addAttributeValue(index) {
                var attributeValue = this.$refs[`value${index}`][0].value
                this.dataForm.attribute[index].value.push(attributeValue)
            },
            deleteAttribute(index) {
                this.dataForm.attribute.splice(index, 1)
            },
            deleteAttributeValue(index, valueIndex) {
                this.dataForm.attribute[index].value.splice(valueIndex)
            },

        }
    }
</script>
